module.exports = __webpack_public_path__ + "static/media/webSystems.eb76c114.png";